/**
 * Created by PanJiaChen on 16/11/18.
 */



/**
	 * 功能：拼接完整图片地址
	 * @param {Object} url
	 */
export  function fullImageUrl(url) {
  if (url == null) {
    return ''
  }
  if (url.startsWith('http')) {
    return url;
  }
  // console.log('url2222',Config.ImageBaseUrl + uni.$u.trim(url))
  return Config.ImageBaseUrl + uni.$u.trim(url);
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */

import CryptoJS from 'crypto-js';
// 定义密钥和初始化向量
let KEY = '079f9fed5748910eba1a4ab89ce4b5c9';
let IV = '2024111411152030';

export function setAES(str) {

  const key = CryptoJS.enc.Utf8.parse(KEY);
  const iv = CryptoJS.enc.Utf8.parse(IV);

  // console.log('key',key);
  var option = {
    iv: iv,
    mode: CryptoJS.mode.CBC, // 使用CBC模式
    padding: CryptoJS.pad.Pkcs7 // 使用Pkcs7填充方式
  };

  var encrypted = CryptoJS.AES.encrypt(str, key, option);
  return encrypted.toString(); // 返回加密后的字符串
}

export function decryptAES(str) {
  const key = CryptoJS.enc.Utf8.parse(KEY);
  const iv = CryptoJS.enc.Utf8.parse(IV);
  var decrypted = CryptoJS.AES.decrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8); // 返回解密后的字符串
}

export function sortParams(params) {
  // 获取所有参数键并排序
  const keys = Object.keys(params).sort();

  // 构建排序后的参数字符串
  let sortedParams = '';
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] !== 'x-sign') {
      const key = keys[i];
      const value = params[key];
      // 忽略值为 undefined 的参数
      if (value === undefined) continue;
      if (i > 0) sortedParams += '&';
      // sortedParams += encodeURIComponent(key) + '=' + encodeURIComponent(value);
      sortedParams += key + '=' + value;
    }
  }
  return sortedParams + '&secret=5748910eba1a4ab8';
}


export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

export function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = DHvs
// module chunks = 8